<template>
  <section class="story-section">
    <div class="story-container">

      <!-- 左侧视觉区：证书窗口 -->
      <div class="left-visual">
        <!-- 模拟终端/窗口标题栏 -->
        <div class="window-bar">
          <div class="dots">
            <span class="dot red"></span>
            <span class="dot yellow"></span>
            <span class="dot green"></span>
          </div>
          <span class="window-title">FCD_PROFILE_identity</span>
        </div>

        <!-- 证书图像区域 -->
        <div class="certificate-box">
          <!-- 左上角和右下角的折角装饰 -->
          <span class="corner tl"></span>
          <span class="corner br"></span>

          <!-- 证书占位内容 -->
          <div class="certificate-content">
            <div class="cert-title">CERTIFICATE OF CREDENTIALS</div>
            <div class="cert-sub">THIS IS TO CERTIFY THAT</div>
            <div class="cert-org">FRAUD COUNSEL DEPARTMENT</div>
            <!-- 模拟中间徽章 -->
            <div class="cert-seal">FCD</div>
            <div class="cert-foot">REGULATED & CERTIFIED</div>
          </div>
        </div>
      </div>

      <!-- 右侧内容区 -->
      <div class="right-content">
        <div class="header">
          <div class="tag">WHO WE ARE</div>
          <h2 class="title">Our <span class="gradient">Story & Foundation</span></h2>

          <!-- 居中分割线 -->
          <div class="divider-container">
            <div class="line"></div>
            <span class="square-icon">[■]</span>
            <div class="line"></div>
          </div>
        </div>

        <div class="paragraphs">
          <p>Fraud Counsel Department was founded by a team of blockchain investigators, digital forensic specialists,
            and cybercrime analysts who recognised a critical gap: victims of cryptocurrency fraud had almost nowhere to
            turn. Traditional law enforcement lacked the tools. Banks couldn't act. The blockchain moved faster than the
            justice system.</p>
          <p>We built Fraud Counsel Department to change that. Using advanced blockchain forensics, proprietary tracing
            technology, and a global enforcement network, we pursue stolen digital assets wherever they go — across
            wallets, chains, exchanges, and jurisdictions.</p>
          <p>Today we operate globally, having reviewed over 5,000 cases across more than 40 countries, recovering funds
            from some of the most sophisticated crypto fraud operations in the world. Every case is handled with the
            same rigour, the same commitment, and the same goal: getting your money back.</p>
        </div>

        <!-- 使命卡片 -->
        <div class="mission-card">
          <div class="mission-title">// OUR MISSION</div>
          <p class="mission-text">To restore trust and financial security in the digital economy by delivering proven
            crypto recovery solutions and protecting individuals and businesses from cyber-enabled fraud — worldwide.
          </p>
        </div>

        <!-- 标签组 -->
        <div class="tags-container">
          <div v-for="tag in tags" :key="tag" class="tag-item">
            <span class="tag-dot"></span> {{ tag }}
          </div>
        </div>

        <!-- 按钮组 -->
        <div class="buttons">
          <button class="btn-primary">⚡ START RECOVERY</button>
          <button class="btn-secondary">▣ Our Services</button>
        </div>
      </div>

    </div>

    <!-- 底部统计条 (包含在组件内) -->
    <div class="stats-bar">
      <div v-for="stat in stats" :key="stat.label" class="stat-item">
        <div class="num">{{ stat.value }}</div>
        <div class="label">{{ stat.label }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StorySection',
  data() {
    return {
      tags: [
        'BLOCKCHAIN FORENSICS', 'DIGITAL INVESTIGATIONS', 'LEGAL ENFORCEMENT',
        'GLOBAL REACH', '24/7 SUPPORT', 'EVIDENCE-BASED'
      ],
      stats: [
        { value: '5,000+', label: 'CASES REVIEWED' },
        { value: '$1.83M', label: 'FUNDS RECOVERED' },
        { value: '94.7%', label: 'SUCCESS RATE' },
        { value: '40+', label: 'COUNTRIES SERVED' },
        { value: '24/7', label: 'LIVE MONITORING' },
        { value: '10+', label: 'ACTIVE SERVICES' }
      ]
    };
  }
}
</script>

<style scoped>
.story-section {
  background-color: #070b14;
  padding: 100px 5% 0;
  color: #fff;
}

.story-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 80px;
}

/* --- 左侧视觉区 --- */
.left-visual {
  width: 100%;
  height: 500px;
}

.window-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #0d1117;
  border: 1px solid #1f2937;
  border-bottom: none;
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
}

.dots {
  display: flex;
  gap: 8px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot.red {
  background: #ff5f56;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #27c93f;
}

.window-title {
  font-family: monospace;
  color: #a0b3cc;
  font-size: 0.9rem;
  margin-left: 10px;
}

.certificate-box {
  position: relative;
  background: #000;
  border: 1px solid #1f2937;
  border-top: none;
  height: 450px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* 四角折线装饰 */
.corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #00ff88;
  z-index: 2;
}

.tl {
  top: 10px;
  left: 10px;
  border-right: none;
  border-bottom: none;
}

.br {
  bottom: 10px;
  right: 10px;
  border-left: none;
  border-top: none;
}

/* 证书主体 */
.certificate-content {
  width: 90%;
  height: 90%;
  background: #12150b;
  border: 1px solid #5a5a3a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #c4b998;
  font-family: serif;
}

.cert-title {
  font-size: 1.2rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  border-bottom: 1px solid #5a5a3a;
  padding-bottom: 10px;
  width: 80%;
}

.cert-sub {
  font-size: 0.8rem;
  color: #8a7a5a;
  margin-bottom: 20px;
}

.cert-org {
  font-size: 2.2rem;
  font-weight: bold;
  color: #e5d8b0;
  border: 2px solid #e5d8b0;
  padding: 10px 20px;
  margin-bottom: 30px;
}

.cert-seal {
  width: 80px;
  height: 80px;
  border: 2px solid #c4b998;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  font-size: 1.2rem;
}

.cert-foot {
  font-size: 0.7rem;
  letter-spacing: 1px;
  color: #8a7a5a;
}

/* --- 右侧内容区 --- */
.header {
  position: relative;
  margin-bottom: 30px;
}

.tag {
  color: #00ff88;
  font-size: 0.9rem;
  letter-spacing: 2px;
  margin-bottom: 15px;
}

.title {
  font-size: 3rem;
  margin: 0 0 20px;
  font-weight: 800;
}

.gradient {
  color: #00ff88;
}

/* 分割线 */
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: -10px;
  left: 0;
}

.line {
  flex: 1;
  height: 1px;
  background-color: #1f2937;
}

.square-icon {
  color: #00ff88;
  font-size: 0.9rem;
  font-family: monospace;
  margin: 0 15px;
}

.paragraphs p {
  color: #a0b3cc;
  font-size: 1.05rem;
  line-height: 1.8;
  margin-bottom: 20px;
}

/* 使命卡片 */
.mission-card {
  background: #0d1117;
  border: 1px solid #1f2937;
  border-radius: 8px;
  padding: 25px;
  margin: 30px 0;
}

.mission-title {
  color: #00ff88;
  font-family: monospace;
  font-size: 0.9rem;
  margin-bottom: 15px;
}

.mission-text {
  color: #d1d5db;
  font-style: italic;
  line-height: 1.6;
  font-size: 1rem;
  margin: 0;
}

/* 标签组 */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
}

.tag-item {
  border: 1px solid #2a303c;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.85rem;
  font-weight: bold;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tag-dot {
  width: 6px;
  height: 6px;
  background: #00ff88;
  border-radius: 50%;
}

/* 按钮组 */
.buttons {
  display: flex;
  gap: 15px;
}

.btn-primary {
  background: linear-gradient(90deg, #a5f3c1, #00d68f);
  color: #000;
  border: none;
  padding: 15px 30px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 0 20px rgba(0, 214, 143, 0.3);
  transition: transform 0.3s;
}

.btn-primary:hover {
  transform: translateY(-3px);
}

.btn-secondary {
  background: transparent;
  border: 1px solid #2a303c;
  color: #fff;
  padding: 15px 30px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-secondary:hover {
  border-color: #00ff88;
  color: #00ff88;
}

/* --- 底部统计条 --- */
.stats-bar {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #1f2937;
  border-bottom: 1px solid #1f2937;
  background: #0d1117;
  text-align: center;
  padding: 30px 0;
}

.num {
  color: #00ff88;
  font-size: 2.5rem;
  font-weight: 800;
  margin: 0 0 10px;
}

.label {
  color: #a0b3cc;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

/* --- 响应式布局 --- */
@media (max-width: 900px) {
  .story-container {
    grid-template-columns: 1fr;
    gap: 40px;
    padding-top: 50px;
  }

  .left-visual {
    display: none;
    /* 移动端隐藏左侧大图片 */
  }

  .title {
    font-size: 2.5rem;
  }

  .buttons {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }

  .stats-bar {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 20px 0;
  }

  .num {
    font-size: 1.8rem;
  }
}

@media (max-width: 600px) {
  .stats-bar {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>